<template>
    <div class="student-canvas">
        <pre>{{ canvas }}</pre>
    </div>
</template>

<script>
export default {
    name: "Canvas",
    props: ['canvas']
}
</script>

<style scoped>

</style>
